import paymentInstance from '../../instance'
import paymentModalLoginInstance from '../../modalLoginInstance'

const deleteTap2PayPaymentSession = (sessionId, hasModalLogin) => {
	return (hasModalLogin ? paymentModalLoginInstance : paymentInstance).delete(`/tap2pay/paymentSessions/${sessionId}`)
}
export default deleteTap2PayPaymentSession
